module.exports = __webpack_public_path__ + "img/person_return.2dd88cd9.svg";